import styled from '@emotion/styled'

export const StyleTabButton = styled.button<any>`
  border: ${(props: any) =>
    `1px solid ${props.theme.colors[!!props?.isActive ? 'primary' : 'white']}`};
  background: ${(props: any) =>
    props.theme.colors[!!props?.isActive ? 'secondary100' : 'white']};
  color: ${(props: any) =>
    props.theme.colors[!!props?.isActive ? 'primary' : 'text100']};
  border-radius: 8px;
  padding: 10px 15px;
`
